module.exports = __webpack_public_path__ + "img/gross-margin-2@2x.008adf6b.png";